import React from 'react';
import { Spin } from 'antd';

const Spinner = ({ size }) => {
  return <Spin size={size} />;
};

export default Spinner;
